<template>
  <div :class="paginaQuestionarioClassName">
    <baseLoader v-if="paginaLoader"></baseLoader>
    <div v-if="answerIdTerminale !== null" :class="rispostaTerminaleInfosClass">
      <div class="row w-100">
        <div class="col-12" align="center">
          
          <div style="max-width: 1155px">
            <div v-if="true" class="row w-100"></div>
            <div v-if="renderTicketComponent && !renderAnswerNoTicket && !isInHoliday" class="row w-100">
              <ticket
                :answerId="answerIdTerminale"
                :surveyId="surveyId"
                :setPaginaLoaderCallback="setPaginaloaderCallback"
                :getPaginaRingraziamentoCallback="
                  getPaginaRingraziamentoCallback
                "
                :staticAnswerShowInputElements="staticAnswerShowInputElements"
              ></ticket>
            </div>
            <div id="question-pre-ticket">
              <div v-if="!renderTicketComponent && !isInHoliday" class="row w-100">
                <!-- <div
                  class="question-pre-ticket-opening w-100 d-flex align-items-center"
                  v-if="renderQuestion"
                >
                  <div class="textarea-pre-ticket w-100">
                    <textArea
                      :labelKey="'question-custom'"
                      :inputId="'question-custom'"
                      :required="true"
                      :ref="'question-pre-ticket'"
                    >
                      <template v-slot:subLabel>
                        <div>
                          <strong>IMPORTANTE</strong>: si informa che ai fini di
                          una efficiente gestione del servizio si darà risposta
                          in via prioritaria ai quesiti posti in modo esaustivo.
                        </div>
                      </template>
                      <template v-slot:nextTextarea>
                        <button
                          class="invia-domanda float-start btn btn-lg"
                          :onClick="inviaDomandaClick"
                        >
                          Invia
                        </button>
                      </template>
                    </textArea>
                  </div>
                </div> -->
                
                <div :class="arrticoliJoomlaLayoutClassname">
                  <articoliJoomla
                    :answerId="answerIdTerminale"
                    :showTitle="false"
                    :onLoadDataEnded="onArticoliJoomlaLoadDataEnded"
                    :onLoadDataStarted="onArticoliJoomlaLoadDataStarted"
                    :setPaginaLoaderCallback="setPaginaloaderCallback"
                  ></articoliJoomla>
                </div>
                <div :class="documentiUtiliLayoutClassname">
                  <documentiUtili
                    :answerId="answerIdTerminale"
                    :onLoadDataEnded="onResourcesLoadDataEnded"
                    :onLoadDataStarted="onResourceLoadDataStarted"
                    :setPaginaLoaderCallback="setPaginaloaderCallback"
                  ></documentiUtili>
                </div>
                <div :class="faqLayoutClassname">
                  <faq
                    :answerId="answerIdTerminale"
                    :onLoadDataEnded="onFaqLoadDataEnded"
                    :onLoadDataStarted="onFaqLoadDataStarted"
                    :setPaginaLoaderCallback="setPaginaloaderCallback"
                  ></faq>
                </div>
                <div class="riepilogo-domande-risposte-wrapper" v-if="renderAnswerNoTicket">
                  <riepilogoDomandeRisposteLog :paginaRingraziamentoLogId="paginaRingraziamentoLogId"/>
                  <div class="text-start mt-2" v-html="intl[$store.state.lang]['no_ticket_html']"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="questionario-content-container col-12" align="center">
        <checkTicketExtraRequest
          :setPaginaLoaderCallback="setPaginaloaderCallback"
          :onRicominciaQuestionarioClickCallback="onRicominciaQuestionarioClickCallback"
        >
          <questionario
            v-if="$store.state.userIsLoggedIn"
            :key="$store.state.userIsLoggedIn"
            :saveAnswerHistoryMode="
              $store.state.libraryWiperConfig.ricordaRisposteQuestionario === 'true'
            "
            ref="questionarioRef"
            :surveyId="surveyId"
            :paginaLoader="paginaLoader"
            :rispostaTerminaleCallback="rispostaTerminaleCallback"
            :rispostaCallback="rispostaCallback"
            :onIndietroClickCallback="onIndietroClickCallback"
            :onRicominciaQuestionarioClickCallback="
              onRicominciaQuestionarioClickCallback
            "
            :rispostaFinaleCallback="rispostaFinaleCallback"
            :setPaginaLoaderCallback="setPaginaloaderCallback"
            :onCreateSurveyLogCallback="onCreateSurveyLogCallback"
            :paginaRingraziamentoAperta="paginaRingraziamentoAperta"
          />
        </checkTicketExtraRequest>
      </div>
    </div>
    <modalInbound />
  </div>
</template>

<script>
import Questionario from "../questionario/Questionario.vue";
import Faq from "../contenitoreFaq/Faq.vue";
import DocumentiUtili from "../documentiUtili/DocumentiUtili.vue";
import ArticoliJoomla from "../articoloJoomla/ArticoliJoomla.vue";
import BaseLoader from "../loaders/baseLoader/BaseLoader.vue";
import TicketDinamico from "../ticket/TicketDinamico.vue";
import CheckTicketExtraRequest from "../checkTicketExtraRequest/CheckTicketExtraRequest.vue";
import RiepilogoDomandeRisposteLog from "../riepilogoDomandeRisposteLog/RiepilogoDomandeRisposteLog.vue";
import intl from "./intl/intl";
import ModalInbound from "../modalInbound/ModalInbound.vue"
import { mapState } from "vuex";

export default {
  name: "pagina-questionario",
  components: {
    questionario: Questionario,
    faq: Faq,
    documentiUtili: DocumentiUtili,
    ticket: TicketDinamico,
    baseLoader: BaseLoader,
    //textArea: TextArea,
    articoliJoomla: ArticoliJoomla,
    checkTicketExtraRequest: CheckTicketExtraRequest,
    riepilogoDomandeRisposteLog: RiepilogoDomandeRisposteLog,
    modalInbound: ModalInbound
  },
  props: {
    surveyId: {
      type: Number,
      default: process.env.VUE_APP_SURVEY_ID_1,
    },
  },

  data: function () {
    return {
      intl: intl,
      answerIdTerminale: null,
      renderFaqComponent: true,
      faqComponentDataLoaded: false,
      documentiUtiliComponentDataLoaded: false,
      renderDocumentiUtiliComponent: true,
      articoliJoomlaComponentDataLoaded: false,
      renderArticoliJoomlaComponent: true,
      renderAnswerNoTicket: false,
      paginaRingraziamentoLogId: null,
      renderTicketComponent: false,
      renderQuestion: false,
      childLoaders: {},
      staticAnswerShowInputElements: [
        {
          required: true,
          name: "question",
          defaultValue: "",
        },
        {
          required: true,
          name: "persona",
          defaultOptions: [
            { value: "Fisica", text: "Fisica" },
            { value: "Giuridica", text: "Giuridica" },
          ],
        },
        {
          required: true,
          name: "elenco_registro",
          defaultOptions: [
            {
              value: "Elenco Agenti e Mediatori",
              text: "Elenco Agenti e Mediatori",
            },
            { value: "Registro Cambiavalute", text: "Registro Cambiavalute" },
            { value: "Registro Compro Oro", text: "Registro Compro Oro" },
            {
              value: "Registro Operatori Valute Virtuali",
              text: "Registro Operatori Valute Virtuali",
            },
            {
              value: "PSP/IMEL e Punti di contatto centrale",
              text: "PSP/IMEL e Punti di contatto centrale",
            },
          ],
        },
        {
          required: true,
          name: "codfisc",
        },
        {
          required: true,
          name: "name",
        },
        {
          required: true,
          name: "mobile",
          pattern: "[0-9]+",
        },
        {
          required: true,
          name: "pec_or_peo_email",
        },
      ],
      paginaQuestionarioLoader: false,
      paginaRingraziamentoAperta: false,
    };
  },
  methods: {
    // metodo scatenato al click del bottone 'invia' sulla textarea della domanda prima di entrare nel ticket.
    // fa comparire il ticket e modifica il valore di default che arriverà alla domanda nel ticket.
    inviaDomandaClick() {
      let questionElement = this.staticAnswerShowInputElements.find(
        (item) => item.name === "question"
      );
      if (questionElement) {
        let defaultValueDomanda = this.$refs["question-pre-ticket"].inputField;
        if (defaultValueDomanda) {
          questionElement.defaultValue = defaultValueDomanda;
        }
      }
      this.renderTicketComponent = true;
      this.renderQuestion = false;
      this.$refs.questionarioRef && this.$refs.questionarioRef.addFakeAnswer();
    },
    setPaginaloaderCallback(value) {
      this.childLoaders = { ...this.childLoaders, ...value };
    },
    getPaginaRingraziamentoCallback(paginaRingraziamentoAperta) {
      this.paginaRingraziamentoAperta = paginaRingraziamentoAperta;
    },
    rispostaTerminaleCallback(answerDetailData, answerInfo) {
      if(answerDetailData?.answerNoTicket?.length > 0){
        this.renderAnswerNoTicket = true
        this.paginaRingraziamentoLogId = this.$store.getters.getSurveyLogId;
      }
      else if (
        answerDetailData?.answerFaq?.length === 0 &&
        answerDetailData?.answerResource?.length === 0 &&
        answerDetailData?.answerTag?.length === 0
      ) {
  
        this.renderTicketComponent = true;
      }
      if (answerInfo.id) {
        this.answerIdTerminale = answerInfo.id;
      }
    },
    rispostaCallback(response, answerInfo) {
      this.answerIdTerminale = null;
    },
    rispostaFinaleCallback(type) {
      switch (type) {
        case "wiper-assistenza-no":
          this.renderTicketComponent = true;
          break;
        case "wiper-assistenza-yes":
          if (this.$store.hasModule("questionarioStore-" + this.surveyId)) {
            this.$store.commit(
              "questionarioStore-" + this.surveyId + "/doResetQuiz"
            );
          }
          if (this.assistenzaPortaleBaserl) {
            window.location.href = this.assistenzaPortaleBaserl;
          }
          return null;
        default:
          return null;
      }
    },

    onIndietroClickCallback() {
      this.answerIdTerminale = null;
      this.renderQuestion = false;
      this.renderTicketComponent = false;
      this.renderAnswerNoTicket = false;
      this.paginaRingraziamentoLogId = null;
    },
    onRicominciaQuestionarioClickCallback() {
      this.paginaRingraziamentoAperta = false;
      this.answerIdTerminale = null;
    },

    onCreateSurveyLogCallback() {
      this.renderTicketComponent = false;
      this.renderAnswerNoTicket = false;
      this.paginaRingraziamentoLogId = null;
    },
    onArticoliJoomlaLoadDataEnded(response, articoli) {
      if (articoli && articoli.length > 0) {
        this.renderArticoliJoomlaComponent = true;
      } else {
        this.renderArticoliJoomlaComponent = false;
      }
    },
    onFaqLoadDataEnded(response, faqs) {
      if (faqs && faqs.length > 0) {
        this.renderFaqComponent = true;
      } else {
        this.renderFaqComponent = false;
      }
      this.faqComponentDataLoaded = true;
    },
    onResourcesLoadDataEnded(response, documenti) {
      if (documenti && documenti.length > 0) {
        this.renderDocumentiUtiliComponent = true;
      } else {
        this.renderDocumentiUtiliComponent = false;
      }
      this.documentiUtiliComponentDataLoaded = true;
    },
    onResourceLoadDataStarted() {
      this.renderDocumentiUtiliComponent = false;
      this.documentiUtiliComponentDataLoaded = false;
    },
    onFaqLoadDataStarted() {
      this.renderFaqComponent = false;
      this.faqComponentDataLoaded = false;
    },
    onArticoliJoomlaLoadDataStarted() {
      this.renderArticoliJoomlaComponent = false;
      this.articoliJoomlaComponentDataLoaded = false;
    },
    async closeSurveyLog() {
      await this.$refs.questionarioRef?.closeSurveyLog();
    }
  },
  watch: {
    async renderTicketComponent(newValue, oldValue) {
      if(newValue === true && oldValue === false && this.isInHoliday){
        if(this.$store.state.libraryWiperConfig?.urlChiusoPerFerie?.startsWith('/') ){
          await this.closeSurveyLog()
          window.location.href = this.$store.state.libraryWiperConfig.urlChiusoPerFerie
        }
      }
    }
    /*   renderQuestion(nuovoValore, vecchioValore) {
      if (nuovoValore === true && vecchioValore === false) {
        // Ottieni l'elemento dal DOM utilizzando l'ID
        var elemento = document.getElementById("question-pre-ticket");

          // Scopri la sua posizione rispetto alla finestra
          var posizione = elemento.getBoundingClientRect().top;

          // Esegui lo scroll
          window.scrollTo({
            top: posizione + window.scrollY,
            behavior: 'smooth' // Opzionale, rende lo scorrimento fluido
          });
        }
      } */
  },
  computed: {
    ...mapState({

      showErroreGenerico(state) {
        return state["erroreGenericoApplicazione"];
      },
    }),
    assistenzaPortaleBaserl: function () {
      return process.env.VUE_APP_URL_ASSISTENZA_PORTALE || null;
    },
    isInHoliday(){
      let isInHoliday = false
      if(this.$store.state.libraryWiperConfig.chiusoPerFerie === "SI"){
        let ferieDal = this.$store.state.libraryWiperConfig.chiusoPerFerieDal
        let ferieAl = this.$store.state.libraryWiperConfig.chiusoPerFerieAl  
        if(!ferieAl && !ferieDal){
          isInHoliday = true
        }else{
          let today = new Date()
          if(ferieDal && ferieAl){
            isInHoliday = today >= new Date(ferieDal) && today <= new Date(ferieAl)
          }else if(ferieDal){
            isInHoliday = today >= new Date(ferieDal)
          }else if(ferieAl){
            isInHoliday = today <= new Date(ferieAl)
          }
        }
      }
      return isInHoliday
    },

    paginaLoader: function () {
      let loaders = Object.keys(this.childLoaders);
      let paginaLoader = false;
      if (this.paginaQuestionarioLoader === true) {
        paginaLoader = true;
      } else if (loaders.length > 0) {
        loaders.map((loader) => {
          if (this.childLoaders[loader] === true) {
            paginaLoader = true;
          }
        });
      }
      return paginaLoader;
    },
    paginaQuestionarioClass: function () {
      if (this.showTicket) {
        return "pagina-questionario ticket";
      }
      return "pagina-questionario";
    },
    rispostaTerminaleInfosClass: function () {
      if(this.showErroreGenerico){
        return "risposta-terminale-container-info d-none"
      }
      else if (
        this.faqComponentDataLoaded &&
        this.documentiUtiliComponentDataLoaded
      ) {
        return "risposta-terminale-container-info visible";
      } else if (this.renderTicketComponent) {
        return "risposta-terminale-container-info visible";
      }
      return "risposta-terminale-container-info invisible";
    },
    paginaQuestionarioClassName: function () {
      if (this.renderTicketComponent) {
        return "pagina-questionario hide-questions ticket-on";
      }
      return "pagina-questionario";
    },
    arrticoliJoomlaLayoutClassname: function () {
      if (this.renderArticoliJoomlaComponent) {
        return "col-12";
      }
      return "col-0";
    },
    documentiUtiliLayoutClassname: function () {
      if (this.renderFaqComponent && this.renderDocumentiUtiliComponent) {
        return "col-xl-4";
      }
      if (!this.renderDocumentiUtiliComponent) {
        return "col-0";
      }
      if (this.renderDocumentiUtiliComponent && !this.renderFaqComponent) {
        return "col-12";
      }
      return "col-0";
    },
    faqLayoutClassname: function () {
      if (this.renderFaqComponent && this.renderDocumentiUtiliComponent) {
        return "col-xl-8";
      }
      if (!this.renderFaqComponent) {
        return "col-0";
      }
      if (!this.renderDocumentiUtiliComponent && this.renderFaqComponent) {
        return "col-12";
      }
      return "col-0";
    },
  },
};
</script>
